import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default function LoadingBoundary(props) {
    return (
        <div className={classnames("position-relative height-100-percent", props.className)}>
            {props.children}
        </div>
    );
}

LoadingBoundary.propTypes = {
    className: PropTypes.any,
};
